import Vue from 'vue'
import Vuex from 'vuex'
import { request } from '@/utils/httpSever'

import industry from './industry'
import JiaJu from './industry/jiaju'
import QiChe from './industry/qiche'
import KongTiao from './industry/kongtiao'
import TiYu from './industry/tiyu'
import FuWuQi from './industry/fuwuqi'
import ShiPinHuiYi from './industry/shipinhuiyi'
import WuYe from './industry/wuye'
import ZhaoMing from './industry/zhaoming'
import YiLiao from './industry/yiliao'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    imgBaseUrl: '../assets/img/',
    dialogBoxShow: false,
    // navShow:true,
    searchResultType: 1,//搜索结果页类型 1、正常 2、我的订阅 3、我的收藏
    sideBarShow: true,//是否显示侧边栏
    sideBarActiveIndex: 0,//当前选中的侧边栏的index
    loginDialogShow: false,//是否显示登录组件
    subscriberShow: false,//是否显示订阅器组件
    token: localStorage.getItem('token') ? localStorage.getItem('token') :
      sessionStorage.getItem('token') ? sessionStorage.getItem('token') :
        '',
    nickName: '',
    userName: '',
    tel: '',
    userid: '',
    hasNewMessage: false,
    subscriberMessageNum: 0,
    openMemberShow: false,
    orderNum: 0,
    invoiceNum: 0,

    /* 后台数据统计相关 start */
    // 数据统计参数
    statisticsParams: {
      region: '', //地区范围筛选项(省、市名称英文逗号拼接)，默认为null或空字符串
      marketType: 1, //1查询同用 2查询自定义
      market: '', //采购市场筛选项(父级采购市场名称)，默认为null或空字符串
      startTime: '', //开始时间(两个字段均有值才会进行查询)，默认为null
      endTime: '', //结束时间(两个字段均有值才会进行查询)，默认为null
      industry: '', //行业筛选项(传递所选父级词)，默认为null或空字符串
      industryType: 1, //行业筛选项类型(与行业筛选项搭配使用) 1查询通用 2查询个人
      suitableTarget: '', //标的物筛选条件(传递筛选的子项英文逗号拼接字符串)，默认为null或空字符串
      chartsSort: 1, //1按金额统计2按数量统计
      searchTitle: '', //字符查询字段
      searchType: 1, //字符筛选类型（1项目名称2品牌3中标供应商4采购人5代理机构）
      userId: '',
      timeType: 1, // 0自定义(不获取环比数据)1月份2季度3年份(不获取环比数据)
      timeStamp: '' // 时间戳
    },
    // 不包内容筛选条件内容
    mustNotIds: '', //不包内容筛选条件(页面上的移除的内容ID逗号拼接)，默认为null或空字符串
    // 当前选择的一级标的物
    oneSubjectMatter: 1,
    // header展示文字数据
    headerTextData: {
      region: { name: '全国范围', id: 1 }, // 地区
      market: { name: '采购市场', id: 2 }, // 市场
      date: { name: '', id: 3 }, // 日期
      iOrS: { name: '全行业', id: 5 } // 行业或标的物
    },
    // 当前激活参数的弹窗
    activeParamsDia: 0,
    // 时间选择弹窗，选择的周期
    selectCycle: 2,
    // statisticsActive: 0
    // 当前是否处于编辑状态
    editCaseStatus: false
    /* 后台数据统计相关 end */
  },
  getters: {
    tokenChange(state) {
      return state.token
    },
    nickNameChange(state) {
      return state.nickName
    }
  },
  mutations: {
    changeLoginDialogShow(state, bool) {
      state.loginDialogShow = bool
    },
    changeSubscriberShow(state, bool) {
      state.subscriberShow = bool
    },
    changeOpenMemberShow(state, bool) {
      state.openMemberShow = bool
    },
    changeSearchResultType(state, val) {
      state.searchResultType = val
    },
    changeToken(state, token) {
      state.token = token
    },
    changeNickName(state, nickName) {
      state.nickName = nickName
    },
    changeTel(state, tel) {
      state.tel = tel
    },
    changeDialogBoxShow(state, bool) {
      state.dialogBoxShow = bool
    },
    changeHasNewMessage(state, bool) {
      state.hasNewMessage = bool
    },
    changeSubscriberMessageNum(state, num) {
      state.subscriberMessageNum = num
    },
    changeOrderNum(state, num) {
      state.orderNum = num
    },
    changeInvoiceNum(state, num) {
      state.invoiceNum = num
    },
    // 改变userid
    changeUserid(state, data) {
      state.userid = data
    },
    // 改变搜索参数(整体)
    changeStatisticsData(state, data) {
      state.statisticsParams = data
    },
    // 改变搜索参数(item)
    changeStatisticsParams(state, { key, value }) {
      state.statisticsParams[key] = value
    },
    // 改变选择的一级标的物
    changOneSubjectMatter(state, data) {
      state.oneSubjectMatter = data
    },
    // 改变header展示数据
    // changeHeaderData(state, data) {
    //   state.headerData = data
    // },
    // 改变当前激活参数的弹窗
    changeActiveParamsDia(state, value) {
      state.activeParamsDia = value
    },
    // 改变header展示文字数据
    changeHeaderTextData(state, { key, value }) {
      state.headerTextData[key] = value
    },
    //改变userName
    changeUserName(state, data) {
      state.userName = data
    },
  },
  actions: {
    async changeOrderNum({ commit }) {
      let res = await request.orderChangeNum()
      if (res.status === 200) {
        commit('changeOrderNum', res.data)
      }
    },
    async changeInvoiceNum({ commit }) {
      let res = await request.invoiceChangeNum()
      if (res.status === 200) {
        commit('changeInvoiceNum', res.data)
      }
    }
  },
  modules: { industry, JiaJu, QiChe, KongTiao, TiYu, FuWuQi, ShiPinHuiYi, WuYe, ZhaoMing, YiLiao }
})
export default store